import React from 'react';
import { Platform, View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { AdminColors } from '../constants/adminColors';
import FontFamily from '../../../constants/fonts';
import { useTheme } from '../../../theme/useTheme';

export interface BreadcrumbItem {
  label: string;
  onPress?: () => void;
}

interface AdminBreadcrumbProps {
  items: BreadcrumbItem[];
}

const AdminBreadcrumb: React.FC<AdminBreadcrumbProps> = ({ items }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';

  return (
    <View style={styles.container}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={index}>
            {item.onPress && !isLast ? (
              <TouchableOpacity onPress={item.onPress} activeOpacity={0.7}>
                <Text style={[styles.link, isDark && { color: colors.brand.primary }]}>
                  {item.label}
                </Text>
              </TouchableOpacity>
            ) : (
              <Text
                style={[
                  styles.text,
                  isLast && styles.current,
                  isDark && { color: isLast ? colors.text.primary : colors.text.disabled },
                ]}
              >
                {item.label}
              </Text>
            )}
            {!isLast && (
              <Text style={[styles.separator, isDark && { color: colors.text.disabled }]}>
                &gt;
              </Text>
            )}
          </React.Fragment>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 10,
  },
  text: {
    fontSize: 14,
    color: AdminColors.textMuted,
    fontFamily: FontFamily.regular,
  },
  link: {
    fontSize: 14,
    color: AdminColors.textLink,
    fontFamily: FontFamily.regular,
  },
  current: {
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.medium,
  },
  separator: {
    fontSize: 14,
    color: AdminColors.gray300,
    fontFamily: FontFamily.regular,
  },
});

export default AdminBreadcrumb;
